import { logAppleAuth } from '../utils/appleAuthDiagnostics';
import React, { useEffect, useState } from 'react';
import { Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { appleSignInEnabled } from '../aws-exports';
import { completeAppleSignIn } from '../utils/completeAppleSignIn';

// React StrictMode remounts effects; exchange/complete each redirect only once.
const callbackParams = new URLSearchParams(window.location.search);
const hasAuthorizationResponse = callbackParams.has('code') && callbackParams.has('state') && !callbackParams.has('error');
let completion;
export default function AppleAuthCallback() {
  const [error, setError] = useState(null);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let active = true;
    logAppleAuth('callback_received', { has_code: callbackParams.has('code'), has_state: callbackParams.has('state'), has_error: callbackParams.has('error') });
    if (!appleSignInEnabled) {
      setError('Apple sign-in is not enabled here.');
      return undefined;
    }
    if (!hasAuthorizationResponse) {
      setError('Apple sign-in was cancelled or the callback is invalid. Please try again.');
      return undefined;
    }
    setError(null);
    completion ||= completeAppleSignIn();
    completion.then(() => {
      if (active) window.location.replace('/dashboard');
    }).catch(err => {
      completion = undefined;
      if (active) setError(err.message || 'Apple sign-in could not be completed. Please return to sign in and try again.');
    });
    return () => { active = false; };
  }, [attempt]);
  return <div className="login-container"><div className="tg-auth-card">
    <h2 className="tg-auth-title">Signing in with Apple</h2>
    {error ? <><Alert variant="danger">{error}</Alert>{appleSignInEnabled && hasAuthorizationResponse && <button type="button" className="btn btn-primary me-3" onClick={() => setAttempt(n => n + 1)}>Retry loading account</button>}<Link to="/dashboard" reloadDocument>Return to sign in</Link></>
      : <p role="status">Completing your sign-in…</p>}
  </div></div>;
}
